import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface RsaSearchCallsModel extends BaseModel {
  variables?: { [key: string]: string } | RsaSearchCallsVariables;
}

export interface RsaSearchCallsVariables {
  Country: string;
  TelephoneNumber: string;
}

export class RsaSearchCallsInitVariables implements RsaSearchCallsVariables {
  Country = '';
  TelephoneNumber = '';
}

export class RsaSearchCallsInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new RsaSearchCallsInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
